import { createEffect, createSignal, untrack } from "solid-js"
import type { Engine } from "../../lib/core/engine/Engine.type"
import isWidthHeightEqual from "../../lib/isWidthHeightEqual"
import createSharedCachedFactory from "./createSharedCachedFactory"

export type GridWidthHeight = {
  width: number
  height: number
}

const useGridWidthHeight = createSharedCachedFactory((
  engine: Engine,
) => {
  function getValue() {
    return {
      width: engine.state.width,
      height: engine.state.height,
    }
  }
  const [getter, setter] = createSignal<GridWidthHeight>(untrack(getValue), {
    equals: isWidthHeightEqual,
  })
  createEffect(() => {
    // console.log('useGridWidthHeight.effect', getValue())
    setter(getValue())
  })
  return getter
})

export default useGridWidthHeight